//API
// export const FETCH_START = 'fetch_start';
// export const FETCH_SUCCESS = 'fetch_success';
export const SHOW_MESSAGE = 'show_message';
export const SHOW_ERROR = 'show_error';
export const HIDE_ALERT = 'hide_alert';
export const TOGGLE_APP_DRAWER = 'toggle_app_drawer';

//APP SETTING
export const TOGGLE_NAV_COLLAPSED = 'toggle_nav_collapsed';
export const SET_INITIAL_PATH = 'set_initial_path';

// UiWise Actions - Layout Actions
export const GET_MENU_SPEC = 'get_menu_spec';
export const GET_QUICK_LINKS = 'get_quick_links';
export const GET_LAYOUT_SPEC = 'get_layout_spec';
export const REMOVE_LAYOUT_SPEC = 'remove_layout_spec';
export const GET_APP_ENDPOINT = 'app-endpoint';

// UiWise Global/App Actions
export const GET_AUTH_INFO = 'get_auth_info';
export const GLOBAL_RESET = 'global_reset';

// UiWise Widget Actions
export const WIDGET_FETCH_START = 'widget_fetch_start';
export const WIDGET_FETCH_SUCCESS = 'widget_fetch_success';
export const WIDGET_FETCH_ERROR = 'widget_fetch_error';
export const WIDGET_RESET_STATE = 'widget_reset_state';
export const WIDGET_RESET_DATA = 'widget_reset_data';
export const WIDGET_FIELD_OPTIONS = 'widget_field_options';
